import { useContext } from "react";
import { SiteSidebarContext } from "../components/context/site-sidebar-context";
import { toNumber } from "lodash";
export var useSiteSidebar = function useSiteSidebar() {
  var context = useContext(SiteSidebarContext);
  var _a = context.color,
      color = _a === void 0 ? '#969696' : _a,
      _b = context.width,
      width = _b === void 0 ? toNumber(process.env.SITE_SIDEBAR_WIDTH) || 56 : _b,
      _c = context.widthMenu,
      widthMenu = _c === void 0 ? toNumber(process.env.SITE_SIDEBAR_WIDTH) || 64 : _c,
      buttons = context.buttons,
      onClick = context.onClick;
  return {
    color: color,
    isAvailable: !!context.isAvailable,
    showFullscreenButton: !!context.showFullscreenButton,
    widthMenu: widthMenu,
    width: width,
    buttons: buttons,
    onClick: onClick
  };
};